export function secondaryMenu(e1: any) {

    var sm = 'secondary-menu';
    var inp = `${sm}__checkbox`;
    var smd = `${sm}__dropdown`;
    var $input = jQuery(`#${inp}`);
    var checked = e1.target.checked;

    if (checked) {

        // IE edge triggering click after change event
        setTimeout(() => {
            jQuery(document).on(`click.${sm}`, (e2: any) => {

                if (e2.which === 1) {
                    // Follow anchor
                    if (!jQuery(e2.delegateTarget.activeElement).is('[href]')) {
                        e2.preventDefault();
                    }

                    $input.prop('checked', false);
                    jQuery(document).off(`click.${sm}`);
                    jQuery(`.${smd}`).off(`click.${sm}-dropdown`);
                }

            });
            jQuery(`.${smd}`).on(`click.${sm}-dropdown`, e3 => e3.stopPropagation());
        }, 0);
    }
}

export function secondaryMenuAuthorities() {

    var ea = 'etdr-authorities';
    var label = `${ea}__label`;
    var $l = jQuery(`.${label}`);
    jQuery(`.${label}`).mousedown(e => e.preventDefault());

    if ($l.height() <= 24) {
        jQuery(`.${ea}`).addClass(`${ea}--invisible`);
    }

    $l.trigger('click');
}
jQuery(() => {

    var id = 'secondary-menu__checkbox';
    var $input = jQuery(`#${id}`);

    if ($input && $input.length) {

        $input
            .prop('checked', false)
            .change(secondaryMenu);
    }

    secondaryMenuAuthorities();
});
